export const errorMessages = {
  requiredField: "This field is required",
  requiredFieldName: (field: string) => `${field} is required`,
  mustMatch: (field: string) => `${field} must match`,
  atLeastXChar: (field: string, min: number) => `${field} must be at least ${min} characters`,
};
